<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <!--       <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Struttura:</label>
                        <b-form-select v-model="filtro.idStruttura" :options="strutturaOptions" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"> 
                        <label class="sa-label-data">Presidio:</label>
                        <b-form-input v-model="filtro.denominazione" type="search" id="denominazione" placeholder="Presidio"></b-form-input>
                    </b-col>
               
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form> -->
        </template>
        <template slot="table-body">
            <strutture-presidi-list-component ref="StrutturePresidiListComponent" @afterLoadData="onAfterLoadData"></strutture-presidi-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import StrutturePresidiListComponent from "../components/StrutturePresidiListComponent.vue";
export default {
    components: { SaPageLayout, StrutturePresidiListComponent },
    data() {
        return {
            filtro: {
                denominazione: null,
                idStruttura: null,
                numero: null,
                descrizione: null,
            },
            strutturaOptions: [],
            listaStrutture: [],
            btnNewVisible: true,
            pathResource: "",
            pathResourceStrutture: "/strutture",
            linkedit: "/strutturapresidi",
            showModalLoading: false,
            cont: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.StrutturePresidiListComponent.loadData();
            me.$refs.StrutturePresidiListComponent.loadCodStrutture();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
